import React from "react";
import { Box, Grid, Chip} from "@mui/material";
import {
  InfoOutlined,
  StorageOutlined,
  DateRangeOutlined,
  
  WarehouseOutlined,
  LocalShippingOutlined,
} from "@mui/icons-material";

import { useWarehouseAllocationDetailContext } from "contexts/WarehouseAllocationDetailContext"; // Context for warehouse allocation details
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import {localizeDateTimeShort} from "utils/dateFormats";
const statusStyles = {
  Pending: {
    backgroundColor: "#FADBD8",
    hoverBackgroundColor: "#F5B7B1",
    textColor: "#C0392B",
  },
  Confirmed: {
    backgroundColor: "#FFF3CD", 
    hoverBackgroundColor: "#FFE8A1", 
    textColor: "#856404", 
  },
  Fulfilled: {
    backgroundColor: "#D4EDDA", 
    hoverBackgroundColor: "#C3E6CB", 
    textColor: "#155724", 
  },
  default: {
    backgroundColor: "#E9ECEF", 
    hoverBackgroundColor: "#D6D8DB", 
    textColor: "#6C757D", 
  },
};

const getStatusStyle = (status) => statusStyles[status] || statusStyles.default;

const WarehouseAllocationBasicDetail = () => {
  const { allocationDetail, loadingAllocation } = useWarehouseAllocationDetailContext();

  return !loadingAllocation ? (
    <Box padding={3}>
      <Grid container spacing={4}>
      <Grid item xs={4}>
      <InformationTile
            icon={() => <WarehouseOutlined color="primary" />}
            title="Allocation ID"
            subtitle={allocationDetail?.allocation_id}
          />
        </Grid>
        {/* Warehouse Name */}
        <Grid item xs={4}>
          <InformationTile
            icon={() => <WarehouseOutlined color="primary" />}
            title="Warehouse ID"
            subtitle={typeof allocationDetail?.warehouse_id === "object"
              ? allocationDetail?.warehouse_id?.warehouse_id
              : allocationDetail?.warehouse_id
          }          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Shipment ID"
            subtitle={typeof allocationDetail?.shipmentId === "object"
              ? allocationDetail?.shipmentId?.shipmentId
              : allocationDetail?.shipmentId
          }          />
        </Grid>

             {/* Total Capacity */}
        <Grid item xs={4}>
          <InformationTile
            icon={() => <StorageOutlined color="primary" />}
            title="Allocated Capacity"
            subtitle={`${allocationDetail?.allocated_capacity || 0} units`}
          />
        </Grid>

        {/* Allocation Date */}
        <Grid item xs={4}>
  <InformationTile
    icon={() => <DateRangeOutlined color="primary" />}
    title="Allocation Time"
    subtitle={
      allocationDetail?.allocation_time
        ? localizeDateTimeShort(allocationDetail.allocation_time)
        : "N/A"
    }
  />
</Grid>

        {/* Allocation Status */}
        <Grid item xs={4}>
  <InformationTile
    icon={() => <InfoOutlined color="primary" />}
    title="Allocation Status"
    subtitle={
      <Box display="flex" flexDirection="column" alignItems="start" mt={1}>
              <Chip
          label={allocationDetail?.status || "Unknown"}
          style={{
            backgroundColor: getStatusStyle(allocationDetail?.status).backgroundColor,
            color: getStatusStyle(allocationDetail?.status).textColor,
            fontWeight: "bold",
            textTransform: "uppercase", 
            fontSize: "0.7rem", 
            height: "20px",
            padding: "0 6px",
            borderRadius: "12px",
            marginTop: "4px",
            width: "auto", 
          }}
          />
      </Box>
    }
  />
</Grid>



        {/* Notes */}
        {/* <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Notes"
            subtitle={allocationDetail?.notes || "No additional notes"}
          />
        </Grid> */}
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default WarehouseAllocationBasicDetail;
